import React from "react";
import Typography from "components/Typography";
import classes from "./GoodsamInsuranceDesktopTableDeductibleTd.module.css";
import cn from 'classnames';
import { tickDarkGreenIcon, closeIcon, explainerIconOutline, bookmarksIcon } from "components/Icon";
import Tooltip from "components/Tooltip/Tooltip";
import { StringItem } from "components/StringItem";
import { BOOLEAN_VALUES } from "../../../constants";

export const GoodsamInsuranceDesktopTableDeductibleTd = (props) => {
  const {
    isGroupStart,
    isGroupEnd,
    isGroup,
    isPlan,
    tip,
    valueString,
    isSelectedPlan
  } = props;

  return (
    <div
      className={cn(
        classes.container,
        isGroupStart && classes.groupStart,
        isGroupEnd && classes.groupEnd,
      )}
    >
      <div
        className={cn(
          classes.containerInner,
          isSelectedPlan && classes.containerInnerSelected,
          isPlan && classes.planContainerInner,
        )}
      >
        <div className={classes.content}>
          <div
            className={cn(
              isGroup && classes.groupContent,
              isPlan && classes.planContent,
            )}
          >
            {isPlan ? (
              <span className={classes.iconPlanContainer}>
                {bookmarksIcon}
              </span>
            ) : null}

            <Typography
              variant="subtitle"
              size="m"
              className={classes.value}
            >
              {valueString}
            </Typography>

            {tip ? (
              <span
                className={classes.tipButton}
              >
                <Tooltip
                  tooltipContainerClassName={classes.tip}
                  tooltipContent={<div dangerouslySetInnerHTML={{ __html: tip }} />}
                  offset={[12, 12]}
                  placement="right"
                >
                  {(ref) => (
                    <span ref={ref} className={classes.tipIcon}>
                      {explainerIconOutline}
                    </span>
                  )}
                </Tooltip>
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
